module.exports = __webpack_public_path__ + "static/media/fridge-light-gray.b2b82454.svg";